<template>
    <!-- Contact section start -->
	<section id="contact-section" class="px-12 lg:px-32 py-16 relative">
        <!-- Main text start -->
		<div class="flex flex-col">
        <h1 class="uppercase text-5xl mb-4 font-semibold ">
			Contact us
		</h1>
        <div class="flex flex-row mt-[40px]">
            <div class="flex flex-col w-full items-center">
                <label for="user_email" class="text-stone-500 text-left">E-mail address</label>
                <input type="email" v-model="emailData.reply_to" name="user_email" id="user_email" class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-1/2">

                <label for="user_message" class="text-stone-500 text-left">Message</label>
                <textarea name="user_message" v-model="emailData.message" id="user_message" cols="30" rows="10" class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-1/2"></textarea>

                <button class="btn w-full md:w-1/2" @click="sendEmail()">Send</button>
            </div>
        </div>
        </div>
		
        <div class="bg-neutral-200 h-44 w-44 md:h-52 md:w-52 rounded-full absolute -top-20 left-0 mt-16 -z-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Contact section end -->
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  data() {
    return {
      emailData: {
        reply_to: '',
        message: '',
      },
      status: '',
    };
  },
  methods: {
    sendEmail() {
      emailjs
        .send(
          'service_k4bv4vd', // Replace with your EmailJS service ID
          'template_uvvok8u', // Replace with your EmailJS template ID
          this.emailData,
          '0gtvm3nrhfBY4LEK2' // Replace with your EmailJS user ID
        )
        .then(
          (response) => {
            this.status = `Email sent successfully! ${response} ` ;
            window.alert('Email sent succesfully!');
          },
          (error) => {
            this.status = 'Failed to send email. Please try again.';
            window.alert('FAILED...', error);
          }
        );
    },
  },

}
</script>

<style>

</style>